<template>
  <component :is="currentComponent"
             v-if="currentComponent"
             :visible.sync="innerVisible"
             :projectId="projectId"
             :fullNode.sync="innerFullNode"
             :customerId="customerId"
             @refreshDetail="$emit('refreshDetail')"/>
</template>

<script>
import BoHeadEvaluationDialog from '../components/BoHeadEvaluationDialog.vue'
import FirstEvaluationDialog from '../components/FirstEvaluationDialog.vue'
import SecondEvaluationDialog from '../components/SecondEvaluationDialog.vue'
import ReviewMeetingDialog from '../components/ReviewMeetingDialog.vue'
import KickoffMeetingDialog from '../components/KickoffMeetingDialog.vue'
import UploadCustomerListDialog from '../components/UploadCustomerListDialog.vue'
import UploadCleanedFilesDialog from '../components/UploadCleanedFilesDialog.vue'
import UploadProjectReportDialog from '../components/UploadProjectReportDialog.vue'
import ProgressShareMeetingDialog from '../components/ProgressShareMeetingDialog.vue'
import ProjectCostConfirmDialog from '../components/ProjectCostConfirmDialog.vue'

export default {
  name: 'ProjectNodeDialog',
  components: {
    BoHeadEvaluationDialog,
    FirstEvaluationDialog,
    SecondEvaluationDialog,
    ReviewMeetingDialog,
    KickoffMeetingDialog,
    UploadCustomerListDialog,
    UploadCleanedFilesDialog,
    UploadProjectReportDialog,
    ProgressShareMeetingDialog,
    ProjectCostConfirmDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
    customerId: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    innerVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
    innerFullNode: {
      get () {
        return this.fullNode
      },
      set (val) {
        this.$emit('update:fullNode', val)
      },
    },
    currentComponent () {
      return this.fullNode ? this.fullNode.nodeDialogComponent : null
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/project/pages/ProjectNodeDialog.vue